module.exports = __webpack_public_path__ + "static/media/SVG_footprint.71b99ffb.svg";